import React, {useState} from "react";
import EstacionamientoHeader from "./EstacionamientoHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import EstacionamientoService from "../../services/EstacionamientoService";
import { Spinner } from "reactstrap";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import Clock from "./Clock";
import EstacionamientoSmallHeader from "./EstacionamientoSmallHeader";
import LogServices from "../../services/LogServices";


const EstacionamientoInicio = () => {
    const navigate = useNavigate();
    const [lugar, setLugar] = useState({lugar: "123"});
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading ] = useState(false);

    const continueHandler = () => {
        //localStorage.setItem("estacionamiento_lugar", lugar.lugar);
        EstacionamientoService.finalizarEstacionamiento(localStorage.getItem("estacionamiento_celular"), localStorage.getItem("estacionamiento_patente"),
        localStorage.getItem("estacionamiento_token"))
        .then((respFinalizar)=>{ 
            if (respFinalizar.data.errorCode == "10"){
                localStorage.setItem("estacionamiento_costo", respFinalizar.data.extra.costo);
                localStorage.setItem("estacionamiento_duracion", respFinalizar.data.extra.duracion);
                setLoading(false);
                localStorage.removeItem("estado_estacionamiento");
                navigate("/estacionamientofin");

                /*EstacionamientoService.cambiarEstadoSensorOcupado(localStorage.getItem("estacionamiento_internalId"), false)
                    .then((respDesocupar)=>{
                        console.log(respDesocupar);
                        setLoading(false);
                        localStorage.removeItem("estado_estacionamiento");
                        navigate("/estacionamientofin");

                    })
                    .catch((errorOcupar)=>{
                        setErrorMessage(errorOcupar);
                        setLoading(false);
                        localStorage.removeItem("estado_estacionamiento");
                        navigate("/estacionamientofin");
                        });*/
               }
            else {
                setErrorMessage(respFinalizar.data.messageError);
                setLoading(false);
                LogServices.log("No se puede finalizar estacionamiento ",localStorage.getItem("estacionamiento_celular"),respFinalizar.message, respFinalizar);
        }
        })
        .catch((error)=>{
            setErrorMessage(error.data);
            setLoading(false);
            LogServices.log("No puede finalizarse estacionamiento ",localStorage.getItem("estacionamiento_celular"), error.message, error);
        })
        setLoading(true);
        
      }
   

    return (
        <>
       <div class="container text-center estacionamientoContent" >
       <EstacionamientoSmallHeader texto="" retorno="/estacionamiento"/>
       <div class="row">
                <div class="col">
                <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/estacionamiento")}}/>
                        <img src="./estacionamient-inicio-3.png" class="imgSubtitleMain" ></img>
                   
                </div>
        </div>
       <div class="row">
            <div class="col">
                <h1>¡Estacionamiento iniciado con &eacute;xito!</h1>
            </div>
        </div>
        <div class="row">
        <div class="col">
                <h1 class="dataIndicator">Patente: {localStorage.getItem("estacionamiento_patente")} <br/> Lugar: {localStorage.getItem("estacionamiento_lugar")}</h1>
            </div>
        </div>
        <div class="row">
        <div class="col">
                <h4>Hora de inicio: {localStorage.getItem("estacionamiento_horaini")}</h4>
               
                <h5>Tiempo transcurrido: <Clock />
           
                '</h5>
            </div>
        </div>
        <div class="row">
               
                <div class="col">
                    <img src="./icon-warning-hand.png" width="50px"/>
                    <div className="buttonContainer">
                        <button className="buttonDanger" onClick={continueHandler}>Finalizar estacionamiento</button>
                    </div>
                </div>
            </div>
           
        </div>
        <p class="errorText" align="center">{errorMessage}</p>
        {loading ?  <div align="center">
   <Spinner color="primary" align="center"/></div>:<></>}
        
        
        
        </>

    );
    }
export default EstacionamientoInicio;